import { BaseContainerModel } from "../../base-container.model";
import * as fromDatatype from '../../../datatype-library/index';

export class StockBinAvailabilityContainer extends BaseContainerModel {
  item_guid: fromDatatype.GuidDataFieldInterface;
  location_guid: fromDatatype.GuidDataFieldInterface;
  available_qty: fromDatatype.NumericDatatypeInterface;
  availableBinList: string[];
}